import { FC } from "react";
import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { UseFormReturn } from "react-hook-form";
import { useMediaQuery } from "react-responsive";
import { ScreenSize } from "@constants/screen-size";

const HomePageTitle: FC<{
  title: string;
  search?: {
    placeholder: string;
    form: UseFormReturn<{ search: string }>;
  };
}> = ({ title, search }) => {
  const isSmScreen = useMediaQuery({
    query: `(max-width: ${ScreenSize.sm}px)`,
  });
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      marginBottom={4}
      gap="16px"
      overflow="hidden"
      flexWrap="wrap"
    >
      {title && (
        <Typography
          component="h1"
          fontSize={{ xs: 24, md: 32 }}
          overflow="hidden"
          textOverflow="ellipsis"
          flexShrink="0"
          whiteSpace="nowrap"
        >
          {title}
        </Typography>
      )}

      {search && (
        <Box marginLeft="auto" width={isSmScreen ? "100%" : undefined}>
          <TextField
            {...search.form.register(`search`)}
            fullWidth
            type="text"
            size="small"
            variant="outlined"
            placeholder={search.placeholder}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchOutlinedIcon />
                  </InputAdornment>
                ),
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default HomePageTitle;
